import React from "react";
import { List, ListItem, ListItemText, ListItemIcon, Typography, } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import MenuIcon from "../MenuIcon";
import { navigationRoutes } from "../../models/navigationRoutes";
const NavigationMenu = ({ toolbarColor, altToolbarColor, fontSize, headerFontSize, open, }) => {
    const location = useLocation();
    const filteredRoutes = navigationRoutes.filter((route) => {
        if (route.MenuID === 1 && !window.location.pathname.includes("/admin/"))
            return true;
        return false;
    });
    return (React.createElement(React.Fragment, null,
        filteredRoutes.map((route, index) => index === 0 && (React.createElement(Typography, { key: "nav-menu-0", component: "h5", sx: {
                margin: "10px 0px 5px 15px",
                color: toolbarColor,
                fontSize: headerFontSize !== null && headerFontSize !== void 0 ? headerFontSize : "inherit",
            } }, open ? "Navigation" : ""))),
        React.createElement(List, null, filteredRoutes.map((route) => (React.createElement(React.Fragment, { key: route.ID },
            React.createElement(ListItem, { key: route.ID, "data-key": route.ID, component: Link, to: route.NavigationDestination },
                React.createElement(ListItemIcon, { sx: {
                        fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : "inherit",
                        color: location.pathname === route.NavigationDestination
                            ? toolbarColor
                            : altToolbarColor !== null && altToolbarColor !== void 0 ? altToolbarColor : toolbarColor,
                    } },
                    React.createElement(MenuIcon, { iconName: route.Icon })),
                React.createElement(ListItemText, { primary: route.DisplayName, sx: {
                        fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : "inherit",
                        color: location.pathname === route.NavigationDestination
                            ? toolbarColor
                            : altToolbarColor !== null && altToolbarColor !== void 0 ? altToolbarColor : toolbarColor,
                    } }))))))));
};
export default NavigationMenu;
